import forOwn from 'lodash.forown';
import isArray from 'lodash.isarray';
import isObject from 'lodash.isobject';
import isString from 'lodash.isstring';
import Raven from 'raven-js';

Raven
  .config(process.env.TRIALS.SENTRY_URL, {
    whitelistUrls: [
      /volusion\.com/i
    ],
    release: process.env.TRIALS.VERSION
  })
  .install();

const debug = true;
const filteredWords = [
  'Password',
  'password'
];

/**
 * Logger class
 * Used throughout the site
 */
export default class Logger {
  constructor() {
    this.category = 'app';
    this.data = [];
    this.method = 'info';
  }

  debug(data) {
    this.method = 'debug';
    this._log(data);
  }

  error(data) {
    this.method = 'error';
    this._log(data);
  }

  exception(e) {
    Raven.captureException(e);
  }

  info(data) {
    this._log(data);
  }

  warn(data) {
    this.method = 'warn';
    this._log(data);
  }

  _log({ category = 'app', data = {}, message = '' }) {
    if (!debug) return;

    Raven.captureBreadcrumb({
      category,
      data: this._filterData(data),
      level: this.method,
      message
    });
  }

  _filterArray(arr) {
    return arr.map(item => this._filterData(item));
  }

  _filterObject(obj) {
    forOwn(obj, (value, key) => {
      obj[key] = this._filterData(value);
    });

    return obj;
  }

  _filterString(str) {
    return (~filteredWords.indexOf(str)) ? '***' : str;
  }

  _filterData(data) {
    if (isString(data)) {
      return this._filterString(data);
    }

    if (isObject(data)) {
      return this._filterObject(data);
    }

    if (isArray(data)) {
      return this._filterArray(data);
    }

    return data;
  }
}
